import { CHECKLIST_STATE } from "../../../other/constants/OtherKeys.jsx";

export const HasChecklistMixin = (target) => class extends target {
  static get fields() {
    return [
      { name: "_checklistStatus", dataSource: "checklist_status", type: "number" },
      { name: "_checklistCount", dataSource: "checklist_count", type: "number" }
    ];
  }

  getEntityChecklists() {
    if (!this.project?.checklistStore || !this.id || !this.entityType) return [];
    return this.project.checklistStore.query(
      (checklist) => checklist[this.entityType] === this.id
    );
  }

  get checklistStatus() {
    if (!this.getEntityChecklists().length) return CHECKLIST_STATE.NO_CHECKLIST;
    return this.get("_checklistStatus") ?? CHECKLIST_STATE.NO_CHECKLIST;
  }

  get checklistCount() {
    if (!this.getEntityChecklists().length) return 0;
    return this.get("_checklistCount") ?? 0;
  }
};
